import { FormRowModule } from '../form-row/form-row.module'
import { BusinessSubcategorySlotsComponent } from './business-subcategory-slots.component'
import { CommonModule } from '@angular/common'
import { BrowserAnimationsModule } from '@angular/platform-browser/animations'
import { NgModule } from '@angular/core'
import { TranslateModule } from '@ngx-translate/core'
import { ContentEditableModule } from '@containers/i18n/content-editable/content-editable.module'
import { NumberInputModule } from '@components/number-input/number-input.module'

@NgModule({
  declarations: [BusinessSubcategorySlotsComponent],
  imports: [
    CommonModule,
    BrowserAnimationsModule,
    FormRowModule,
    TranslateModule,
    ContentEditableModule,
    NumberInputModule,
  ],
  exports: [BusinessSubcategorySlotsComponent],
})
export class BusinessSubcategorySlotsModule {}
